import { createStore } from "redux";
import { casherReducer } from "../reducer/reducer";
 import { applyMiddleware } from "redux";
import thunk from "redux-thunk";
export  const store = createStore(casherReducer, applyMiddleware(thunk))